import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = `${config.baseWorkflowUrl}/api/v1/`
export const workFlowBaseUploadUrl = `${workFlowBaseUrl}system_user_review/upload/`
export const workFlowBaseDownloadUrl = workFlowBaseUrl

export const getSystemUserReview = (params) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/`,
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const createSystemUserReview = (data) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/`,
    data: data,
    method: 'post'
  })
}

export const detailSystemUserReview = (id) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/${id}/`,
    method: 'get'
  })
}

export const deleteSystemUserReview = (id) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/${id}/`,
    method: 'delete'
  })
}

export const stageUpdate = (data) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/${data.id}/stage_update/`,
    method: 'put',
    data: data
  })
}

export const designatedProduct = (data) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/${data.id}/designated_product/`,
    method: 'put',
    data: data
  })
}

export const upload = (id) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/upload/`,
    method: 'post'
  })
}

export const download = (id) => {
  return axios.request({
    url: `${workFlowBaseUrl}system_user_review/${id}/download/`,
    method: 'get',
    responseType: 'blob',
    mode: 'base'
  })
}
